import React from 'react'
import { getImageUrl } from '../../helper/constants';

const ServiceCard = ({data}) => {
  return (
    <div className="service_card">
      <div className="product_card_image">
        <img src={getImageUrl(data?.assets?.url)} />{" "}
      </div>
      <div className="service_card_name">{data?.name}</div>
    </div>
  );
}

export default ServiceCard